import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeAppointmentComponent } from './appointment.component';
import { MeAppointmentBookedCardComponent } from './booked-card/booked-card.component';
import { MeAppointmentBookingCardComponent } from './booking-card/booking-card.component';
import { MeAppointmentBookingPageComponent } from './booking-page/booking-page.component';

const routes: Routes = [
    { path: '', component: MeAppointmentComponent },
    { path: 'booking-card', component: MeAppointmentBookingCardComponent },
    { path: 'booked-card', component: MeAppointmentBookedCardComponent },
    { path: 'booking/:cituroId', component: MeAppointmentBookingPageComponent },
    { path: 'booking', redirectTo: 'booking/', pathMatch: 'full'},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MeAppointmentRoutesModule {

}
